import clientAppEnhance0 from '/home/radic/projects/@radic-console/node_modules/@vuepress/theme-default/lib/client/clientAppEnhance.js'
import clientAppEnhance1 from '/home/radic/projects/@radic-console/node_modules/@vuepress/plugin-theme-data/lib/client/clientAppEnhance.js'
import clientAppEnhance2 from '/home/radic/projects/@radic-console/node_modules/@vuepress/plugin-toc/lib/client/clientAppEnhance.js'
import clientAppEnhance3 from '/home/radic/projects/@radic-console/src/.vuepress/clientAppEnhance.ts'

export const clientAppEnhances = [
  clientAppEnhance0,
  clientAppEnhance1,
  clientAppEnhance2,
  clientAppEnhance3,
]
